module.exports = __webpack_public_path__ + "media/base/subcontractor_big-5c9812e2.svg";